import React, { useEffect, useState, useRef } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
  useNavigationType,
  ScrollRestoration,
} from "react-router-dom";
import { Navbar } from "../components/ui/Navbar";
import { connect } from "react-redux";
import { ArsenalScreen } from "../components/arsenal/ArsenalScreen";
import BowlerScreen from "../components/bowler/BowlerScreen";
import BowlersScreen from "../components/bowlers/BowlersScreen";
import DashboardScreen from "../components/dashboard/DashboardScreen";
import JobBoardDashboardScreen from "../components/dashboard/JobBoardDashboardScreen";
import { JobBoardBallServiceScreen } from "../components/ball/JobBoardBallServiceScreen";
import { HelpScreen } from "../components/help/HelpScreen";
import { SettingsScreen } from "../components/settings/SettingsScreen";
import { MobileTopBar } from "../components/ui/MobileTopBar";
import { BallScreen } from "../components/ball/BallScreen";
import { BallPrint } from "../components/ball/BallPrint";
import { useTranslation } from "react-i18next";
import { getVideoSettings } from "../utils/utils";
import { ProfileScreen } from "../components/profile/ProfileScreen";
import { DevicesScreen } from "../components/devices/DevicesScreen";
import { setCustomer } from "../components/bowlers/bowlers.redux";
import {
  ballAddNew,
  setShowConfirmDeleteArsenal,
} from "../components/arsenal/arsenal.redux";
import { specsheetAddNew } from "../components/specsheet/specsheet.redux";
import ScanQueueScreen from "../components/specsheet/ScanQueueScreen";
import ScanReviewScreen from "../components/specsheet/ScanReviewScreen";
import RequestLoader from "../components/ui/RequestLoader";
import styled from "styled-components";
import { Payment } from "../components/payment/Payment";
import { AttachmentPrint } from "../components/ball/AttachmentPrint";
import { GalleryPrint } from "../components/bowler/GalleryPrint";
import { createJob } from "../components/arsenal/arsenal.redux";

const GlobalMargin = styled.div`
  width: 100%;
  height: 100%;
  height: -webkit-fill-available;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  overflow-y: auto;
`;

export const DashboardRoutes = connect(
  (state) => {
    return {
      deviceInfo: state.userSession.deviceInfo,
      pluginSubscriptions: state.plugin.pluginSubscriptions,
      jobServices: state.plugin.jobServices,
      plugin_settings: state.plugin.plugin_settings,
      pluginSubscriptions: state.plugin.pluginSubscriptions,
      selectedCustomerID: state.bowlers.selectedCustomer?.id,
      selectedBallID: state.balls.currentBall?.id,
    };
  },
  {
    setCustomer,
    specsheetAddNew,
    ballAddNew,
    createJob,
    setShowConfirmDeleteArsenal,
  },
)(({
  setCustomer,
  specsheetAddNew,
  ballAddNew,
  createJob,
  selectedCustomerID,
  selectedBallID,
  deviceInfo,
  pluginSubscriptions,
  setShowConfirmDeleteArsenal,
}) => {
  const { t } = useTranslation();
  const containerRef = useRef();
  const navigate = useNavigate();
  let location = useLocation();
  const navigationType = useNavigationType();
  const isPortrait = deviceInfo.isPortrait;
  const [keyPath, setKeyPath] = useState({
    pathname: "",
    label: "",
    specification: (e) => {},
  });

  const handleKey = (pathname, label) => {
    let specificationAdd = (e) => {};
    let regexpPages = /arsenal|bowler|bowlers|settings|job_board/i;

    if (pathname === "bowlers") {
      specificationAdd = () => {
        setCustomer({ bowler: {} });
      };
    } else if (pathname === "bowler") {
      specificationAdd = () => {
        specsheetAddNew({});
      };
    } else if (pathname === "arsenal") {
      specificationAdd = () => {
        ballAddNew({});
      };
    } else {
      specificationAdd = getVideoSettings;
    }
    setKeyPath(() => ({
      ...keyPath,
      pathname: pathname,
      label: label,
      specification: specificationAdd,
    }));
  };

  useEffect(() => {
    const isBallCard = /arsenal\/(.+)\/ball\/(.+)/.test(location.pathname);

    const isArsenalScreen = /arsenal\/(.+)/.test(location.pathname);
    if (!isBallCard && isArsenalScreen && navigationType === "REPLACE") {
      navigate(-1);
    }
    containerRef.current.scrollTo(0, 0);
  }, [location, navigationType]);

  useEffect(() => {
    const keyPath = location.pathname.split("/", 2)[1];
    let regexpPages = /arsenal|bowler|bowlers|settings/i;
    let validPage = regexpPages.test(keyPath);
    if (validPage) {
      if (keyPath === "bowler") {
        handleKey(keyPath, `+ ${t("form.label.add")} Spec Sheet`);
      } else if (keyPath === "bowlers") {
        handleKey(keyPath, `+ ${t("form.label.add")} Bowler`);
      } else if (keyPath === "arsenal") {
        handleKey(keyPath, `+ ${t("form.label.add")} Ball`);
      } else {
        handleKey(keyPath, `${t("form.label.watch_tutorials")}`);
      }
    } else {
      handleKey(keyPath, "");
    }
  }, [location]);

  const handleBack = () => {
    navigate(-1);
  };

  const isPrintBall =
    /print\/(.+)\/ball\/(.+)/.test(location.pathname) ||
    /print\/(.+)/.test(location.pathname);

  return (
    <>
      {isPortrait
        ? !isPrintBall && (
            <MobileTopBar
              goTo={keyPath.pathname}
              titleSpecification={keyPath.label}
              handleSpecification={keyPath.specification}
              createJob={createJob}
              pluginSubscriptions={pluginSubscriptions}
              selectedBallID={selectedBallID}
              selectedCustomerID={selectedCustomerID}
              setShowConfirmDeleteArsenal={setShowConfirmDeleteArsenal}
            />
          )
        : !isPrintBall && <Navbar isPortrait={isPortrait} />}

      <GlobalMargin ref={containerRef}>
        <ScrollRestoration />
        <Routes>
          <Route path="/" element={<DashboardScreen />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="login" element={<Navigate to="/" replace={true} />} />
          <Route path="register" element={<Navigate to="/" replace={true} />} />
          <Route
            path="arsenal/:bowlerID/ball/:ballID"
            element={<BallScreen />}
          />
          <Route path="print/:bowlerID/ball/:ballID" element={<BallPrint />} />
          <Route
            path="print/:bowlerID/specsheet/:specsheetID"
            element={<BallPrint />}
          />
          <Route
            path="print/:bowlerID/specsheet/:specsheetID/attachment/:attachmentIndex"
            element={<AttachmentPrint />}
          />
          <Route
            path="print/:bowlerID/attachment/:attachmentIndex"
            element={<GalleryPrint />}
          />
          <Route path="print/:bowlerID" element={<BallPrint />} />
          <Route path="arsenal/:bowlerID" element={<ArsenalScreen />} />
          <Route
            path="arsenal/:bowlerID/ball/:ballID/job/:jobID"
            element={<JobBoardBallServiceScreen />}
          />
          <Route path="bowlers" element={<BowlersScreen />} />
          {/* The scan lives at its own address rather than in a window over
              the bowlers list: a row opens its review at /scan/:jobId, which
              survives a reload and can be come back to. */}
          <Route path="scan" element={<ScanQueueScreen />} />
          <Route path="scan/:jobId" element={<ScanReviewScreen />} />
          {/* The same review, reached from a bowler's own sheet. The
              bowler is in the address so a reload lands back where it
              started and knows where to return to. */}
          <Route
            path="bowler/:bowlerID/scan/:jobId"
            element={<ScanReviewScreen />}
          />
          <Route path="bowler/:bowlerID" element={<BowlerScreen />} />
          <Route path="dashboard" element={<DashboardScreen />} />
          <Route path="help" element={<HelpScreen />} />
          <Route path="settings" element={<SettingsScreen />} />
          <Route path="profile" element={<ProfileScreen />} />
          <Route path="devices" element={<DevicesScreen />} />
          {pluginSubscriptions.indexOf("JOB_BOARD") >= 0 && (
            <Route path="job_board" element={<JobBoardDashboardScreen />} />
          )}
        </Routes>
      </GlobalMargin>
      {isPortrait && !isPrintBall && <Navbar isPortrait={isPortrait} />}
      <RequestLoader />
    </>
  );
});
